import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cva } from "class-variance-authority";

import { cn } from "lib/utils";

const Tabs = TabsPrimitive.Root;

const tabsListVariants = cva("tw-flex", {
  variants: {
    variant: {
      default:
        "tw-inline-flex tw-h-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-muted tw-p-1 tw-text-muted-foreground",
      charter:
        "tw-flex-col tw-items-stretch tw-justify-start tw-bg-transparent tw-text-muted-foreground",
    },
  },
  defaultVariants: { variant: "default" },
});

const tabsTriggerVariants = cva(
  "tw-inline-flex tw-items-center tw-gap-4 tw-ring-offset-background tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50 [&_svg]:tw-size-5 [&_svg]:tw-shrink-0",
  {
    variants: {
      variant: {
        default:
          "tw-justify-center tw-whitespace-nowrap tw-rounded-md tw-px-3 tw-py-1 tw-text-sm tw-font-medium data-[state=active]:tw-bg-background data-[state=active]:tw-text-foreground data-[state=active]:tw-shadow",
        charter:
          "tw-justify-between tw-whitespace-normal tw-border-b tw-border-border tw-py-6 tw-text-left tw-text-xl tw-font-normal hover:tw-text-foreground data-[state=active]:tw-border-primary data-[state=active]:tw-text-primary max-[850px]:tw-whitespace-nowrap max-[850px]:tw-px-4 max-[850px]:tw-py-4 max-[850px]:tw-text-base",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

const TabsList = React.forwardRef(({ className, variant, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(tabsListVariants({ variant }), className)}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef(
  ({ className, variant, ...props }, ref) => (
    <TabsPrimitive.Trigger
      ref={ref}
      className={cn(tabsTriggerVariants({ variant }), className)}
      {...props}
    />
  ),
);
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "tw-mt-2 tw-ring-offset-background focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2",
      className,
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
